import { ActionTypes } from '../../../constants';

export const renameThematicSelection = (thematicSelectionName: string) => {
  return {
    type: ActionTypes.RENAME_THEMATIC_SELECTION,
    thematicSelectionName,
  };
};
